import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { NOTIFICATIONS_IN_APP_TOPIC_QUERY_KEY } from 'Data/keys/QueryKeys';
import { NotificationApiV2 } from 'Data/Notification.api.v2';

export const useQueryInAppTopicNotifications = (
  constructionSiteId: number,
) => {
  const { data, refetch, isLoading, isFetching, error } = useQuery({
    queryKey: [NOTIFICATIONS_IN_APP_TOPIC_QUERY_KEY, Number(constructionSiteId)],
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: !!constructionSiteId,
    queryFn: async () => {
      const response = await NotificationApiV2.listInAppTopicNotifications(constructionSiteId);
      return response.data.data;
    },
  });

  const dataDefault = useMemo(() => [], []);

  return {
    data: data ?? dataDefault,
    refetch,
    isLoading,
    isFetching,
    error,
  };
};
